<template>
  <div class="wx-box">
    <div class="wx-header">
      <h2 class="wx-title">提货通知</h2>
      <el-input v-model="input" size="small" placeholder="输入订单号查询" prefix-icon="el-icon-search"></el-input>
    </div>
    <div class="wx-card" v-for="(d, i) in data" :key="i" @click="handler(d)">
      <p class="wx-card__title"><strong>{{d.orderNumber}}</strong></p>
      <p class="wx-card__address"><span>地址</span><strong>{{d.adress}}</strong></p>
      <p><span>预约时间</span><strong>{{d.date}}</strong><span class="m-l-10">电话</span><strong>{{d.phone}}</strong></p>
      <!-- <p></p> -->
      <p class="wx-card__bum">{{d.number}}<small>箱</small></p>
    </div>
    <!-- Form -->
    <el-dialog title="提货" :visible.sync="dialogFormVisible" top="0" width="100%">
      <el-form :model="form" size="small">
        <el-form-item label="订单号" :label-width="formLabelWidth" class="width50">{{form.orderNumber}}</el-form-item>
        <el-form-item label="应收" :label-width="formLabelWidth" class="width50">{{form.number}}箱</el-form-item>
        <el-form-item label="实收(箱)" :label-width="formLabelWidth">
          <el-input v-model.lazy="form.test"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      data: [
        {
          orderNumber: "NB678611",
          adress: '深圳市龙岗区暴走大事件',
          phone: '0755-6321666',
          date: '2018-05-15 19:30:00',
          number: '10'
        },
        {
          orderNumber: "NB678678",
          adress: '深圳市杨美地铁站第三工业区3栋3楼',
          phone: '0755-6321563',
          date: '2018-05-10 12:00:00',
          number: '17'
        }
      ],
      formLabelWidth: "70px",
      dialogFormVisible: false,
      form: {
        orderNumber: "",
        number: ''
      }
    };
  },
  components: {},
  created() {},
  computed: {},
  methods: {
    //搜索
    onSubmit() {
      console.log("搜索");
    },
    handler(d) {
      this.dialogFormVisible = true;
      this.form = JSON.parse(JSON.stringify(d));
    }
  },
  mounted() {
    this.$nextTick(function() {
      document.addEventListener('touchstart',function (event) {  
          if(event.touches.length>1){  
              event.preventDefault();  
          }  
      })  
      var lastTouchEnd=0;  
      document.addEventListener('touchend',function (event) {  
          var now=(new Date()).getTime();  
          if(now-lastTouchEnd<=300){  
              event.preventDefault();  
          }  
          lastTouchEnd=now;  
      },false)  
    })
  }
};
</script>

<style lang="scss" scoped>
.wx-box {
  background-color: #f3f3f4;
  min-height: 100vh;
}
.wx-header {
  padding: 30px 15px 15px;
  background-color: #fff;
  margin-bottom: 10px;
  .wx-title {
    color: #141414;
    margin-bottom: 10px;
  }
}
.wx-card {
  position: relative;
  padding: 12px;
  margin: 0 8px;
  border-radius: 6px;
  color: #333;
  background-color: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .1);
  + .wx-card{
    margin-top: 8px;
  }
  p{
    font-size: 12px;
    + p{
      margin-top: 6px;
    }
    span{
      margin-right: 4px;
    }
  }
  .wx-card__title{
    margin-bottom: 10px;
    font-size: 16px;
  }
  .wx-card__address{
    max-width: 80%;
  }
  .wx-card__bum{
    position: absolute;
    right: 12px;
    top: 50%;
    margin-top: -32px;
    font-size: 30px;
    color: #409EFF;
    small{
      font-size: 12px;
    }
  }
}
.m-l-10{
  margin-left: 8px;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/phonepickup.vue